module.exports = __webpack_public_path__ + "public/images/shark.92ce93493f51b6e6232da70b5c39ddba.svg";